import React from 'react';
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { OrganizerMarketingPersonChip } from '../../../modules/services/marketingPersonService';
import translate from '../../../i18n/translate';

interface AlreadyAssignedConfirmDialogProps {
  open: boolean;
  organizerName?: string;
  /** Marketing persons the organizer is already bound to. */
  assignedTo: OrganizerMarketingPersonChip[];
  onCancel: () => void;
  onConfirm: () => void;
  confirming?: boolean;
}

const AlreadyAssignedConfirmDialog: React.FC<AlreadyAssignedConfirmDialogProps> = ({
  open,
  organizerName,
  assignedTo,
  onCancel,
  onConfirm,
  confirming,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle color="warning.main" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <WarningAmberIcon color="warning" />
      {translate('marketingPersonsAlreadyAssignedTitle')}
    </DialogTitle>
    <DialogContent dividers>
      <Typography variant="body2">
        {organizerName ? <b>{organizerName}: </b> : null}
        {translate('marketingPersonsAlreadyAssignedText')}
      </Typography>
      <List dense>
        {assignedTo.map((p) => (
          <ListItem key={p.assignmentId} disableGutters>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <PersonIcon color="warning" />
            </ListItemIcon>
            <ListItemText primary={p.name || p.phone} secondary={p.name ? p.phone : undefined} />
            {p.isDisabled && (
              <Chip label={translate('marketingPersonsStatusDisabled')} size="small" sx={{ mr: 0.5 }} />
            )}
            <Chip label={`ID: ${p.marketingPersonId}`} size="small" variant="outlined" color="warning" />
          </ListItem>
        ))}
      </List>
      <Typography variant="body2" fontWeight="bold">
        {translate('marketingPersonsAlreadyAssignedQuestion')}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="warning">{translate('marketingPersonsNo')}</Button>
      <Button onClick={onConfirm} color="warning" variant="contained" disabled={confirming}>
        {translate('marketingPersonsYes')}
      </Button>
    </DialogActions>
  </Dialog>
);

export default AlreadyAssignedConfirmDialog;
